import { render, staticRenderFns } from "./gradient.global.vue?vue&type=template&id=4a5b8cc6&"
import script from "./gradient.global.vue?vue&type=script&lang=js&"
export * from "./gradient.global.vue?vue&type=script&lang=js&"
import style0 from "./gradient.global.vue?vue&type=style&index=0&id=4a5b8cc6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports